export const defaultTheme = {
    font: {
        weight: {
            regular: 400,
            medium: 500,
            semiBold: 600,
            bold: 700,
        },
        family: {
            primary: 'Lato, Arial, sans-serif',
            secondary: 'Montserrat, Arial, sans-serif',
        },
        size: {
            base: '16px',
            small: '14px',
        },
    },
    shadow: {
        low: '0 0.2rem 0.4rem 0 rgba(0,0,0,0.16)',
        middle: '0 0.4rem 0.8rem 0 rgba(0,0,0,0.12)',
        high: '0 0.8rem 1.6rem 0 rgba(0,0,0,0.08)',
    },
    borderRadius: {
        default: '0.2rem',
        medium: '0.4rem',
        large: '0.8rem',
    },
    dimensions: {
        maxContentWidth: '128rem',
    },
    // Use the breakpoints below instead!
    deprecatedScreen: {
        mobilePortraitMaximum: '479.9px',
        mobileLandscapeMinimum: '480px',
        mobileLandscapeMaximum: '767.9px',
        tabletPortraitMinimum: '768px',
        tabletPortraitMaximum: '991.9px',
        tabletLandscapeMinimum: '992px',
        tabletLandscapeMaximum: '1199.9px',
        desktopMinimum: '1200px',
    },
    breakpoints: {
        xs: { min: '0px', max: '479.9px' },
        s: { min: '480px', max: '767.9px' },
        m: { min: '768px', max: '991.9px' },
        l: { min: '992px', max: '1199.9px' },
        xl: { min: '1200px', max: '9999.9px' },
    },
    color: {
        darkPurple: '#400f4c',
        midPurple: '#791093',
        purple: '#8a2d87',
        indigo: '#282637',
        white: '#ffffff',
        green: '#16835b',
        red: '#ba0000',
        pink: '#da285a',
        orange: '#c05119',
        teal: '#138081',
        yellow: '#fac800',
        grey1: '#f9f9f9',
        grey2: '#ebebeb',
        grey3: '#dbdbdb',
        grey4: '#bfbfbf',
        grey5: '#909090',
        grey6: '#686666',
        grey7: '#3c3b3b',
        black: '#000000',
        purpleShade20: '#4a1647',
        purpleShade10: '#6a2167',
        purpleTint10: '#a83ba4',
        purpleTint20: '#c04bbc',
        purpleTint30: '#d45dcf',
        purpleTint40: '#e373de',
        purpleTint50: '#ee8cea',
        purpleTint60: '#f6aaf3',
        purpleTint70: '#fbcaf9',
        purpleTint80: '#fddafc',
        purpleTint90: '#ffeafe',
        indigoShade20: '#08070a',
        indigoShade10: '#181721',
        indigoTint10: '#494664',
        indigoTint20: '#68638b',
        indigoTint30: '#837dac',
        indigoTint40: '#9a94c6',
        indigoTint50: '#afa9da',
        indigoTint60: '#c2bce9',
        indigoTint70: '#d3cef4',
        indigoTint80: '#e2dffb',
        indigoTint90: '#f0eeff',
        greenShade20: '#074a31',
        greenShade10: '#0c6746',
        greenTint10: '#2ba072',
        greenTint20: '#3bb789',
        greenTint30: '#59cba1',
        greenTint40: '#7cdbb8',
        greenTint50: '#a0e7cd',
        greenTint60: '#bef0de',
        greenTint70: '#d5f7ea',
        greenTint80: '#e2fcf3',
        greenTint90: '#f0fff9',
        redShade20: '#870000',
        redShade10: '#a10000',
        redTint10: '#cb0b0b',
        redTint20: '#dc2929',
        redTint30: '#e54747',
        redTint40: '#ee7070',
        redTint50: '#f59898',
        redTint60: '#fab9b9',
        redTint70: '#fdd1d1',
        redTint80: '#fee2e2',
        redTint90: '#fff0f0',
        tealShade20: '#075557',
        tealShade10: '#0b6b6c',
        tealTint10: '#169b9b',
        tealTint20: '#36b2b4',
        tealTint30: '#54c6c7',
        tealTint40: '#77d6d7',
        tealTint50: '#9ae3e4',
        tealTint60: '#b9edee',
        tealTint70: '#cff5f5',
        tealTint80: '#defbfb',
        tealTint90: '#f0ffff',
        pinkShade20: '#a60a36',
        pinkShade10: '#c61648',
        pinkTint10: '#e73869',
        pinkTint20: '#ef507d',
        pinkTint30: '#f56f95',
        pinkTint40: '#f993b0',
        pinkTint50: '#fcb4c8',
        pinkTint60: '#fdcfdc',
        pinkTint70: '#fee0e9',
        pinkTint80: '#ffeaf0',
        pinkTint90: '#fff5f8',
        darkPurpleShade20: '#040105',
        darkPurpleShade10: '#230829',
        darkPurpleTint10: '#651c77',
        darkPurpleTint20: '#852b9b',
        darkPurpleTint30: '#a03fb8',
        darkPurpleTint40: '#b758ce',
        darkPurpleTint50: '#cb76e0',
        darkPurpleTint60: '#dc9aed',
        darkPurpleTint70: '#ecc2f6',
        darkPurpleTint80: '#f4d7fb',
        darkPurpleTint90: '#fceeff',
        yellowTint40: '#fef9d7',
        yellowTint30: '#fef1b0',
        yellowTint20: '#fde888',
        yellowTint10: '#fcd83f',
        yellowShade10: '#fdb21b',
        yellowShade20: '#fe9c20',
        orangeTint20: '#ff8524',
        orangeTint10: '#e06b1f',
        orangeShade10: '#a64606',
        orangeShade20: '#823503',
        orangeShade30: '#5e2601',
        transparent: 'transparent',
    },
    spacing: {
        0: '0',
        0.5: '0.2rem',
        1: '0.4rem',
        2: '0.8rem',
        3: '1.2rem',
        4: '1.6rem',
        5: '2.0rem',
        6: '2.4rem',
        7: '2.8rem',
        8: '3.2rem',
        9: '3.6rem',
        10: '4.0rem',
        11: '4.4rem',
        12: '4.8rem',
        13: '5.2rem',
        14: '5.6rem',
        15: '6.0rem',
        16: '6.4rem',
        17: '6.8rem',
        18: '7.2rem',
    },
};
